module.exports = __webpack_public_path__ + "img/ciaz.870b963d.svg";